import { getAllTimeLendingStats } from '@/shared/graphql/lp/lending';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { useLendingPools } from './useLendingPools';

export const useAllTimeLendingStats = () => {
  const {
    totalSuppliedUsd,
    totalBorrowedUsd: activeLoansUsd,
    isLoading: isLendingPoolsLoading,
  } = useLendingPools();

  const { data: statsData, isLoading: isAllTimeLendingStatsLoading } = useGqlQuery(
    getAllTimeLendingStats,
    {
      context: { clientName: 'lpProcessor' },
      refetchInterval: 12_000,
    },
  );

  return {
    tvlUsd: totalSuppliedUsd ?? 0,
    activeLoansUsd,
    allTimeBorrowedUsd: statsData?.loans?.agg?.sum?.amountValueUsd,
    totalFeesUsd: statsData?.loanFees?.agg?.sum?.totalAmountValueUsd,
    totalPoolFeesUsd: statsData?.loanFees?.agg?.sum?.poolFeePortionAmountValueUsd,
    totalNetworkFeeUsd: statsData?.loanFees?.agg?.sum?.networkFeePortionAmountValueUsd,
    isLoading: isLendingPoolsLoading || isAllTimeLendingStatsLoading,
  };
};
